import { render, staticRenderFns } from "./PermitProcedureTable.vue?vue&type=template&id=76f80a59"
import script from "./PermitProcedureTable.vue?vue&type=script&lang=js"
export * from "./PermitProcedureTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports